import type Store from "@ember-data/store";
import ChatSendMessageForcComponent from "parog-web/components/chat/send-message-forc";
import type Patient from "parog-web/models/patient";
import type AnalyticsService from "parog-web/services/analytics";

interface Payload {
  willSendMessage: boolean;
  chatMessage: string;
}

interface Params {
  store: Store;
  patient: Patient;
  analytics: AnalyticsService;
}

/**
 * This function helps to save a model that has been used by the 'chat/send-message-forc' component.
 * The model passed to this component will have two properties set :
 *  - willSendMessage
 *  - chatMessage
 * This function will use it to create a chat message accordingly.
 *
 * @param payload.willSendMessage - If yes send the chat message if it exists.
 * @param payload.chatMessage - The chat message to send
 */
export default async function (
  payload: Payload,
  { store, analytics, patient }: Params
) {
  const chatMessageKey = ChatSendMessageForcComponent.chatMessageKey;
  const willSendMessageKey = ChatSendMessageForcComponent.willSendMessageKey;

  if (payload[willSendMessageKey] && payload[chatMessageKey]) {
    if (!store || !patient) {
      throw `Impossible to save the chat message '${payload[chatMessageKey]}' without the 'store' and the 'patient' . `;
    }

    const chatMessage = payload[chatMessageKey].trim();

    if (chatMessage) {
      const chatMessageJe = store.createRecord(
        "patient-chat-message-sent-journal-event",
        {
          occurredAt: new Date(),
          patient,
          body: payload[chatMessageKey]
        }
      );
      if (analytics) {
        analytics.trackJeCreation(chatMessageJe);
      }
      await chatMessageJe.save();
    }
  }
}
